import { Component, OnInit } from "@angular/core";
import { ComponentInterface } from "../../models/component.interface";
import { ComponentConfig } from "../../models/component-config.interface";
import { DashboardService } from "../../../../../services/dashboard.service";

@Component({
  selector: "app-text",
  templateUrl: "./text.component.html",
  styleUrls: ["text.component.css"],
})
export class TextComponent implements ComponentInterface, OnInit {
  config: ComponentConfig;

  title: string = "";
  subtitle: string;
  text: string = "";

  isLoading: boolean;
  constructor(private _dashboardService: DashboardService) {}

  ngOnInit() {
    this.isLoading = true;
    this._dashboardService
      .getBloccoSlider(this.config.token)
      .subscribe((blocco) => {
        this.text = blocco.descrizione;
        this.title = blocco.titolo;
        this.subtitle = blocco.sottotitolo;
        this.isLoading = false;
      });
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/text/text.component.ts